import React, { useCallback } from 'react';
import Button from '@splunk/react-ui/Button';
import { _ } from '@splunk/ui-utils/i18n';
import { useSearchContext } from '@splunk/dashboard-context';

interface RunSearchesButtonProps {
    modalStep: number;
    onProgress: React.Dispatch<React.SetStateAction<number>>;
    layoutIds: string[];
}

type RunSearchesButtonContentProps = Pick<
    RunSearchesButtonProps,
    'onProgress' | 'layoutIds'
>;

const RunSearchesButtonContent = ({
    layoutIds,
    onProgress,
}: RunSearchesButtonContentProps) => {
    const searchApi = useSearchContext();

    const handleRunSearches = useCallback(() => {
        searchApi.setLayoutsToActive({ layoutIds });
        onProgress(1);
    }, [layoutIds, searchApi, onProgress]);

    return (
        <Button
            appearance="primary"
            label={_('Run searches')}
            onClick={handleRunSearches}
            disabled={layoutIds?.length ? undefined : 'dimmed'}
        />
    );
};

export const RunSearchesButton = ({
    modalStep,
    ...rest
}: RunSearchesButtonProps) => {
    if (modalStep !== 0) {
        return null;
    }

    return <RunSearchesButtonContent {...rest} />;
};
